<template>
    <div class="ask-main">
        <div class="header">
            <div class="ask-info">
                <div class="title">题目：{{ interaction.title }}</div>
                <div class="content">描述：{{ interaction.content }}</div>
            </div>
            <div class="switch-btns" v-if="isLecturer">
                <a class="btn btn-primary no-radius btn-block"
                   @click="handleSwitchBtnClick('scope')">{{ scope == 'checkin' ? '选择全部学员' : '只选实到学员' }}</a>
            </div>
        </div>
        <div class="content">
            <div class="user-num">
                {{ users.length }} 人
            </div>
            <div class="user-list-container">
                <div class="user" v-for="user in users" :key="user.user_id"
                     @click="isLecturer && handleSelectUser(user)">
                    <div class="avatar"><img :src="user.user.avatar_url" alt=""></div>
                    <div class="name">{{ user.user.name }}</div>
                    <div v-if="isSelected(user.user_id)" class="selected">
                        <i class="icon icon-success"></i>
                    </div>
                </div>
            </div>
            <div v-if="isLecturer">
                <div v-if="userIsEmpty" class="user-empty">
                    所有学生都已经提问完啦~
                </div>
                <div v-else class="current-user" :style="{'opacity': currentUser?1:0}">
                    <div class="title">当前被提问学员</div>
                    <div class="user">
                        <img :src="currentUser && currentUser.user.avatar_url" alt="">
                        <div class="name">{{ currentUser && currentUser.user.name }}</div>
                    </div>
                </div>
                <div v-if="interaction.status == 1 && !userIsEmpty" class="text-center mt-2">
                    <button type="button" class="btn btn-primary no-radius px-4" @click="randomUser">随机点名</button>
                </div>
                <div class="text-center mt-3">
                    <button v-if="isLecturer" type="button" class="btn btn-lg no-radius px-5"
                            :class="[interaction.status == 1 ? 'btn-danger' : 'btn-success']"
                            @click="updateStatus">
                        {{ interaction.status == 1 ? '结束提问' : '开启提问' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AskContent",
    props: {
        interaction: Object,
        scope: String,
        defaultUsers: {
            type: Array,
            default() {
                return []
            }
        },
        records: Array,
        isLecturer: {
            type: Boolean,
            default: false
        },
        submitUrl: String,
        updateStatusUrl: String,
    },
    data() {
        return {
            currentUser: null,
            innerUsers: null,
            recordUserIds: [],
            timer: null,
        }
    },
    computed: {
        users() {
            return this.innerUsers || this.defaultUsers;
        },
        isSelected() {
            return function (userId) {
                return this.isLecturer && this.recordUserIds.includes(userId)
            }
        },
        userIsEmpty() {
            return this.users.filter(rec => !this.recordUserIds.includes(rec.user_id)).length <= 0;
        }
    },
    mounted() {
        this.recordUserIds = this.records.length > 0 ? this.records.map(rec => rec.user_id) : []

        if (!this.isLecturer) {
            const url = window.location.href
            this.timer = setInterval(() => {
                $.get(url, {}, (resp) => {
                    this.innerUsers = resp
                })
            }, 2000)
        }
    },
    beforeDestroy() {
        if(this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
        handleSwitchBtnClick(name) {
            const url = new URL(window.location.href);
            let val;
            switch (name) {
                case 'scope':
                    val = this.scope == 'all' ? 'checkin' : 'all'
                    break
            }

            val && url.searchParams.set(name, val)

            window.location.href = url.href
        },
        handleSelectUser(user) {
            if (this.interaction.status != 1 || !this.isLecturer || this.recordUserIds.includes(user.user_id)) {
                return
            }

            this.saveRecord(user)
        },
        randomUser() {
            let users = this.users.filter(rec => !this.recordUserIds.includes(rec.user_id)).map(rec => rec)
            let key = Math.floor((Math.random() * users.length))
            let user = users[key]

            this.saveRecord(user)
        },
        saveRecord(user) {
            this.currentUser = user
            this.recordUserIds.push(user.user_id)

            $.ajax({
                type: 'POST',
                url: this.submitUrl,
                data: JSON.stringify({
                    user_id: user.user_id
                }),
                contentType: 'application/json',
            })
        },
        updateStatus() {
            if (!this.isLecturer) {
                return
            }
            $.ajax({
                type: 'PUT',
                url: this.updateStatusUrl,
                data: {},
                contentType: 'application/json',
                success: common.ajax_callback,
                error: common.error
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/common/variables';
@import '../../../sass/common/mixins';

.ask-main {
    border: 1px solid #ccc;
    height: 700px;
    border-radius: 10px;
    padding: 20px;
    background-color: white;

    .header {
        display: flex;
        padding-bottom: 10px;
        border-bottom: 1px solid #ccc;
        min-height: 100px;

        .ask-info {
            flex: 1;

            .title {
                margin-bottom: 10px;
                font-size: 18px;
                color: #5d5d5d;
                font-weight: bolder;
            }
        }

        .switch-btns {
            width: 150px;
            margin-left: 10px;
        }
    }

    .content {
        position: relative;

        .user-num {
            position: absolute;
            top: -20px;
            right: 0;
            padding: 3px 10px;
            background-color: #20b2aa;
            opacity: 0.8;
            color: white;
            border-radius: 3px;
        }

        .user-list-container {
            margin-top: 20px;
            width: 100%;
            height: 220px;
            overflow-y: auto;
            display: flex;
            flex-wrap: wrap;

            .user {
                width: 80px;
                height: 90px;
                margin: 0px 5px 10px 5px;
                padding: 5px;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                position: relative;

                .selected {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 100%;
                    width: 100%;
                    text-align: center;
                    background-color: rgba(128, 128, 128, .3);
                    border-radius: 5px;

                    i.icon {
                        font-size: 40px;
                        color: $green;
                    }
                }

                div {
                    &:not(:last-child) {
                        margin-bottom: 5px;
                    }

                    &.avatar {
                        img {
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                        }
                    }

                    &.name {
                        @include text_overflow(1);
                    }
                }
            }
        }

        .user-empty {
            height: 175px;
            text-align: center;
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 28px;
            color: #afafaf;
        }

        .current-user {
            width: 250px;
            height: 175px;
            margin: 20px auto 0 auto;
            text-align: center;
            border: 1px solid #ccc;
            position: relative;
            padding: 20px;
            border-radius: 10px;

            .title {
                position: absolute;
                top: -18px;
                left: 50px;
                font-size: 20px;
                background-color: white;
                width: 150px;
            }

            .user {
                img {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                }

                .name {
                    margin-top: 10px;
                }
            }
        }
    }
}
</style>
